import { render, staticRenderFns } from "./TrackGameForm.vue?vue&type=template&id=5130f0b3&"
import script from "./TrackGameForm.vue?vue&type=script&lang=js&"
export * from "./TrackGameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports